module.exports = __webpack_public_path__ + "img/StMAS.0abc83ea.png";